import React, { useState, useEffect } from 'react'
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom'
import Dashboard from './Dashboard'
import VanSalesList from './VanSalesList'
import VansList from './VansList'
import VanForm from './VanForm'
import MetricDetail from './MetricDetail'
import VanSalesHistogram from './VanSalesHistogram'
import Layout from './Layout'
import Login from './Login'

// Inventory System
import InventoryDashboard from './InventoryDashboard'
import PartsList from './PartsList'
import PartForm from './PartForm'
import PartView from './PartView'
import ConfigurationsList from './ConfigurationsList'
import ConfigurationForm from './ConfigurationForm'
import OptionsList from './OptionsList'
import OptionForm from './OptionForm'
import CompleteBuild from './CompleteBuild'
import BuildsList from './BuildsList'
import BuildView from './BuildView'
import UpdateInventory from './UpdateInventory'

export default function App() {
  const [authState, setAuthState] = useState({ loading: true, loggedIn: false, user: null })

  useEffect(() => {
    // Check authentication status on mount
    fetch('/api/current_user')
      .then(response => response.json())
      .then(data => {
        setAuthState({
          loading: false,
          loggedIn: data.logged_in,
          user: data.user || null
        })
      })
      .catch(() => {
        setAuthState({ loading: false, loggedIn: false, user: null })
      })
  }, [])

  if (authState.loading) {
    return (
      <div className="flex justify-center items-center h-screen">
        <div className="text-gray-500">Loading...</div>
      </div>
    )
  }

  if (!authState.loggedIn) {
    return (
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </Router>
    )
  }

  // Employees may use the inventory tool but not view financial data.
  const canViewFinancials = authState.user?.role === 'admin'

  // Employees land on the inventory dashboard as their home; financial routes
  // redirect them there. Admins see the financial Dashboard at "/".
  const financialRoute = (element) =>
    canViewFinancials ? element : <Navigate to="/inventory" replace />

  return (
    <Router>
      <Layout user={authState.user}>
        <Routes>
          <Route path="/" element={canViewFinancials ? <Dashboard /> : <InventoryDashboard />} />
          <Route path="/van-sales" element={financialRoute(<VanSalesList />)} />
          <Route path="/vans" element={financialRoute(<VansList />)} />
          <Route path="/vans/new" element={financialRoute(<VanForm />)} />
          <Route path="/vans/:id/edit" element={financialRoute(<VanForm />)} />
          <Route path="/vans/:id/view" element={financialRoute(<VanForm />)} />
          <Route path="/metrics/van_sales_histogram" element={financialRoute(<VanSalesHistogram />)} />
          <Route path="/metrics/:metricType" element={financialRoute(<MetricDetail />)} />
          {/* Inventory System Routes */}
          <Route path="/inventory" element={<InventoryDashboard />} />
          <Route path="/parts" element={<PartsList />} />
          <Route path="/parts/new" element={<PartForm />} />
          <Route path="/parts/:id" element={<PartView />} />
          <Route path="/parts/:id/edit" element={<PartForm />} />
          <Route path="/configurations" element={<ConfigurationsList />} />
          <Route path="/configurations/new" element={<ConfigurationForm />} />
          <Route path="/configurations/:id/edit" element={<ConfigurationForm />} />
          <Route path="/options" element={<OptionsList />} />
          <Route path="/options/new" element={<OptionForm />} />
          <Route path="/options/:id/edit" element={<OptionForm />} />
          <Route path="/completebuild" element={<CompleteBuild />} />
          <Route path="/builds" element={<BuildsList />} />
          <Route path="/builds/:id" element={<BuildView />} />
          <Route path="/update_inventory" element={<UpdateInventory />} />
          <Route path="/login" element={<Navigate to="/" replace />} />
        </Routes>
      </Layout>
    </Router>
  )
}
